<template>
  <div>
    <body class="__variable_f4926d __variable_5c52a9">
      <div>
        <noscript
          ><img
            src="https://sb.scorecardresearch.com/p?c1=2&amp;c2=20631572&amp;cv=3.6.0&amp;cj=1"
        /></noscript>
        <header class="curseforge-header">
          <nav>
            <button class="mobile-menu-opener" aria-label="Navigation Menu">
              <svg viewBox="0 0 24 24">
                <path
                  class="hamburger-top"
                  d="M2,4v-2h20v2z"
                  fill="currentcolor"
                ></path>
                <path
                  class="hamburger-middle"
                  d="M2,12v-2h20v2z"
                  fill="currentcolor"
                ></path>
                <path
                  class="hamburger-bottom"
                  d="M2,20v-2h20v2z"
                  fill="currentcolor"
                ></path>
              </svg>
            </button>
            <!-- <a
              href="/"
              class="curseforge-logo"
              title="curse forge"
              aria-label="Goto home page"
            >
              <img class="desktop-logo" :src="topLogoStyle2" />
            </a> -->
            <div class="nav-links-container">
              <ul class="nav-links">
                <li>
                  <a href="/" class="nav-link"
                    >Browse<svg>
                      <use href="/"></use></svg
                  ></a>
                  <div class="sub-nav-container">
                    <div class="sub-nav">
                      <div class="mover" style="width: 0"></div>
                      <div class="sub-nav-inner">
                        <div class="sub-nav-block">
                          <h2>
                            <a href="/" class="more-link"
                              >Browse all (107)<svg>
                                <use href="/"></use></svg
                            ></a>
                          </h2>
                          <ul class="sub-nav-links-list">
                            <li>
                              <a
                                href="/"
                                class="sub-nav-link"
                                target=""
                                rel="noopener noreferrer"
                                ><img
                                  id="row-image"
                                  alt="icon"
                                  loading="lazy"
                                  width="24"
                                  height="24"
                                  decoding="async"
                                  data-nimg="1"
                                  style="color: transparent"
                                  src="https://media.forgecdn.net/avatars/1070/13/638605220544214742.webp"
                                />Minecraft</a
                              >
                            </li>
                            <li>
                              <a
                                href="/"
                                class="sub-nav-link"
                                target=""
                                rel="noopener noreferrer"
                                ><img
                                  id="row-image"
                                  alt="icon"
                                  loading="lazy"
                                  width="24"
                                  height="24"
                                  decoding="async"
                                  data-nimg="1"
                                  style="color: transparent"
                                  src="https://media.forgecdn.net/avatars/1070/17/638605223094593241.webp"
                                />The Sims 4</a
                              >
                            </li>
                            <li>
                              <a
                                href="/"
                                class="sub-nav-link"
                                target=""
                                rel="noopener noreferrer"
                                ><img
                                  id="row-image"
                                  alt="icon"
                                  loading="lazy"
                                  width="24"
                                  height="24"
                                  decoding="async"
                                  data-nimg="1"
                                  style="color: transparent"
                                  src="https://media.forgecdn.net/avatars/63/986/636148993918069601.png"
                                />World of Warcraft</a
                              >
                            </li>
                            <li>
                              <a
                                href="/"
                                class="sub-nav-link"
                                target=""
                                rel="noopener noreferrer"
                                ><img
                                  id="row-image"
                                  alt="icon"
                                  loading="lazy"
                                  width="24"
                                  height="24"
                                  decoding="async"
                                  data-nimg="1"
                                  style="color: transparent"
                                  src="https://media.forgecdn.net/avatars/1070/18/638605223934776497.webp"
                                />Ark Survival Ascended</a
                              >
                            </li>
                            <li>
                              <a
                                href="/"
                                class="sub-nav-link"
                                target=""
                                rel="noopener noreferrer"
                                ><img
                                  id="row-image"
                                  alt="icon"
                                  loading="lazy"
                                  width="24"
                                  height="24"
                                  decoding="async"
                                  data-nimg="1"
                                  style="color: transparent"
                                  src="https://media.forgecdn.net/avatars/652/316/638053973637065420.png"
                                />Minecraft Bedrock</a
                              >
                            </li>
                            <li>
                              <a
                                href="/"
                                class="sub-nav-link"
                                target=""
                                rel="noopener noreferrer"
                                ><img
                                  id="row-image"
                                  alt="icon"
                                  loading="lazy"
                                  width="24"
                                  height="24"
                                  decoding="async"
                                  data-nimg="1"
                                  style="color: transparent"
                                  src="https://media.forgecdn.net/avatars/1070/16/638605222444192313.webp"
                                />StarCraft II</a
                              >
                            </li>
                            <li>
                              <a
                                href="/"
                                class="sub-nav-link"
                                target=""
                                rel="noopener noreferrer"
                                ><img
                                  id="row-image"
                                  alt="icon"
                                  loading="lazy"
                                  width="24"
                                  height="24"
                                  decoding="async"
                                  data-nimg="1"
                                  style="color: transparent"
                                  src="https://media.forgecdn.net/avatars/1070/101/638605301275466053.webp"
                                />Kerbal Space Program</a
                              >
                            </li>
                            <li>
                              <a
                                href="/"
                                class="sub-nav-link"
                                target=""
                                rel="noopener noreferrer"
                                ><img
                                  id="row-image"
                                  alt="icon"
                                  loading="lazy"
                                  width="24"
                                  height="24"
                                  decoding="async"
                                  data-nimg="1"
                                  style="color: transparent"
                                  src="https://media.forgecdn.net/avatars/652/739/638054967147418836.png"
                                />American Truck Simulator</a
                              >
                            </li>
                            <li>
                              <a
                                href="/"
                                class="sub-nav-link"
                                target=""
                                rel="noopener noreferrer"
                                ><img
                                  id="row-image"
                                  alt="icon"
                                  loading="lazy"
                                  width="24"
                                  height="24"
                                  decoding="async"
                                  data-nimg="1"
                                  style="color: transparent"
                                  src="https://media.forgecdn.net/avatars/1070/14/638605221454973991.webp"
                                />Stardew Valley</a
                              >
                            </li>
                            <li>
                              <a
                                href="/"
                                class="sub-nav-link"
                                target=""
                                rel="noopener noreferrer"
                                ><img
                                  id="row-image"
                                  alt="icon"
                                  loading="lazy"
                                  width="24"
                                  height="24"
                                  decoding="async"
                                  data-nimg="1"
                                  style="color: transparent"
                                  src="https://media.forgecdn.net/avatars/65/488/636162973579653614.png"
                                />Terraria</a
                              >
                            </li>
                            <li>
                              <a
                                href="/"
                                class="sub-nav-link"
                                target=""
                                rel="noopener noreferrer"
                                ><img
                                  id="row-image"
                                  alt="icon"
                                  loading="lazy"
                                  width="24"
                                  height="24"
                                  decoding="async"
                                  data-nimg="1"
                                  style="color: transparent"
                                  src="https://media.forgecdn.net/avatars/652/762/638054972820516108.png"
                                />WildStar</a
                              >
                            </li>
                            <li>
                              <a
                                href="/"
                                class="sub-nav-link"
                                target=""
                                rel="noopener noreferrer"
                                ><img
                                  id="row-image"
                                  alt="icon"
                                  loading="lazy"
                                  width="24"
                                  height="24"
                                  decoding="async"
                                  data-nimg="1"
                                  style="color: transparent"
                                  src="https://media.forgecdn.net/avatars/1069/302/638604223320170936.png"
                                />Hogwarts Legacy</a
                              >
                            </li>
                            <li>
                              <a
                                href="/"
                                class="sub-nav-link"
                                target=""
                                rel="noopener noreferrer"
                                ><img
                                  id="row-image"
                                  alt="icon"
                                  loading="lazy"
                                  width="24"
                                  height="24"
                                  decoding="async"
                                  data-nimg="1"
                                  style="color: transparent"
                                  src="https://media.forgecdn.net/avatars/77/677/636174916166063366.png"
                                />World of Tanks</a
                              >
                            </li>
                            <li>
                              <a
                                href="/"
                                class="sub-nav-link"
                                target=""
                                rel="noopener noreferrer"
                                ><img
                                  id="row-image"
                                  alt="icon"
                                  loading="lazy"
                                  width="24"
                                  height="24"
                                  decoding="async"
                                  data-nimg="1"
                                  style="color: transparent"
                                  src="https://media.forgecdn.net/avatars/936/141/638413534976321166.jpg"
                                />Palworld</a
                              >
                            </li>
                            <li>
                              <a
                                href="/"
                                class="sub-nav-link"
                                target=""
                                rel="noopener noreferrer"
                                ><img
                                  id="row-image"
                                  alt="icon"
                                  loading="lazy"
                                  width="24"
                                  height="24"
                                  decoding="async"
                                  data-nimg="1"
                                  style="color: transparent"
                                  src="https://media.forgecdn.net/avatars/76/698/636173120361240569.png"
                                />Runes of Magic</a
                              >
                            </li>
                            <li>
                              <a
                                href="/"
                                class="sub-nav-link"
                                target=""
                                rel="noopener noreferrer"
                                ><img
                                  id="row-image"
                                  alt="icon"
                                  loading="lazy"
                                  width="24"
                                  height="24"
                                  decoding="async"
                                  data-nimg="1"
                                  style="color: transparent"
                                  src="https://media.forgecdn.net/avatars/652/751/638054969923607845.png"
                                />Rift</a
                              >
                            </li>
                            <li>
                              <a
                                href="/"
                                class="sub-nav-link"
                                target=""
                                rel="noopener noreferrer"
                                ><img
                                  id="row-image"
                                  alt="icon"
                                  loading="lazy"
                                  width="24"
                                  height="24"
                                  decoding="async"
                                  data-nimg="1"
                                  style="color: transparent"
                                  src="https://media.forgecdn.net/avatars/77/689/636174976208356224.png"
                                />The Elder Scrolls V: Skyrim</a
                              >
                            </li>
                            <li>
                              <a
                                href="/"
                                class="sub-nav-link"
                                target=""
                                rel="noopener noreferrer"
                                ><img
                                  id="row-image"
                                  alt="icon"
                                  loading="lazy"
                                  width="24"
                                  height="24"
                                  decoding="async"
                                  data-nimg="1"
                                  style="color: transparent"
                                  src="https://media.forgecdn.net/avatars/77/188/636173283407439352.png"
                                />The Elder Scrolls Online</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div class="sub-nav-block" style="width: 288px">
                          <h2>Hackathon now live</h2>
                          <a href="/" aria-label="Hackathon now live Promo"
                            ><img
                              width="288"
                              height="184"
                              src="https://media.forgecdn.net/navbar-image-urls/navbar-image-url_cca6a556-d5f8-4ecd-b5a6-620a04598d25.webp"
                              alt=""
                          /></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <a href="/" class="nav-link"
                    >Create<svg>
                      <use href="/"></use></svg
                  ></a>
                  <div class="sub-nav-container">
                    <div class="sub-nav">
                      <div class="mover" style="width: 0"></div>
                      <div class="sub-nav-inner">
                        <div class="sub-nav-block">
                          <h2>MOD AUTHORS</h2>
                          <ul class="sub-nav-links-list">
                            <li>
                              <a
                                href="/"
                                class="sub-nav-link"
                                target="_blank"
                                rel="noopener noreferrer"
                                >Become an Author</a
                              >
                            </li>
                            <li>
                              <a
                                href="/"
                                class="sub-nav-link"
                                target="_blank"
                                rel="noopener noreferrer"
                                >Start a Project</a
                              >
                            </li>
                            <li>
                              <a
                                href="/"
                                class="sub-nav-link"
                                target="_blank"
                                rel="noopener noreferrer"
                                >Project Submission Guide</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div class="sub-nav-block">
                          <h2>MODDING TOOL DEVELOPERS</h2>
                          <ul class="sub-nav-links-list">
                            <li>
                              <a
                                href="/"
                                class="sub-nav-link"
                                target="_blank"
                                rel="noopener noreferrer"
                                >Apply for an API Key</a
                              >
                            </li>
                            <li>
                              <a
                                href="/"
                                class="sub-nav-link"
                                target="_blank"
                                rel="noopener noreferrer"
                                >Documentation</a
                              >
                            </li>
                            <li>
                              <a
                                href="/"
                                class="sub-nav-link"
                                target="_blank"
                                rel="noopener noreferrer"
                                >Terms &amp; Conditions</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div class="sub-nav-block">
                          <h2>SOCIAL</h2>
                          <ul class="sub-nav-links-list">
                            <li>
                              <a
                                href="/"
                                class="sub-nav-link"
                                target="_blank"
                                rel="noopener noreferrer"
                                >Join Our Discord!</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div class="sub-nav-block" style="width: 288px">
                          <h2>Hackathon now live</h2>
                          <a href="/" aria-label="Hackathon now live Promo"
                            ><img
                              width="288"
                              height="184"
                              src="https://media.forgecdn.net/navbar-image-urls/navbar-image-url_3905d135-21c3-4a17-8954-a5ac3fa1ec29.webp"
                              alt=""
                          /></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <a href="/" class="nav-link"
                    >Studios<svg>
                      <use href="/"></use></svg
                  ></a>
                  <div class="sub-nav-container">
                    <div class="sub-nav">
                      <div class="mover" style="width: 0"></div>
                      <div class="sub-nav-inner">
                        <div class="sub-nav-block">
                          <h2>GAME DEVELOPERS</h2>
                          <ul class="sub-nav-links-list">
                            <li>
                              <a
                                href="/"
                                class="sub-nav-link"
                                target="_blank"
                                rel="noopener noreferrer"
                                >Unlock Modding for Your Game</a
                              >
                            </li>
                            <li>
                              <a
                                href="/"
                                class="sub-nav-link"
                                target="_blank"
                                rel="noopener noreferrer"
                                >Documentation</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div class="sub-nav-block" style="width: 288px">
                          <h2>CurseForge chosen for Hogwarts Legacy modding</h2>
                          <a
                            href="/"
                            aria-label="CurseForge chosen for Hogwarts Legacy modding Promo"
                            ><img
                              width="288"
                              height="184"
                              src="https://media.forgecdn.net/navbar-image-urls/navbar-image-url_1fb15ce2-efb0-40e8-831b-0324ae16b478.webp"
                              alt=""
                          /></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
              <ul class="mobile-more-options">
                <li>
                  <a class="kebab-menu-link" href="/">Surprise me</a>
                </li>
                <li class="kebab-menu-divider"></li>
                <li>
                  <a class="kebab-menu-link" href="/"
                    ><img
                      src="https://static-beta.curseforge.com/images/cf_legacy.png"
                      alt="legacy flame"
                    />Legacy</a
                  >
                </li>
              </ul>
            </div>
            <ul class="top-actions">
              <li>
                <a
                  class="link-btn btn-secondary premium-button-container link-btn-icon"
                  href="/"
                  target="_self"
                  data-tooltip-id="curseforge-tooltip"
                  data-tooltip-content="Go Premium"
                  rel="  noopener"
                >
                  <div class="premium-button-text">Go Premium</div></a
                >
              </li>
              <li>
                <a
                  class="link-btn btn-primary link-btn-icon"
                  href="/"
                  target="_self"
                  data-tooltip-id="curseforge-tooltip"
                  data-tooltip-content="Get CurseForge App"
                  rel="  noopener"
                >
                  <div class="download-app-button-text">
                    Get CurseForge App
                  </div></a
                >
              </li>
            </ul>
            <div class="divider"></div>
            <div class="header-kebab">
              <button class="kebab-button" aria-label="More options">
                <svg id="icon-kebab" viewBox="0 0 20 21">
                  <path
                    d="M10 5.76172C11.1046 5.76172 12 4.86629 12 3.76172C12 2.65715 11.1046 1.76172 10 1.76172C8.89543 1.76172 8 2.65715 8 3.76172C8 4.86629 8.89543 5.76172 10 5.76172Z"
                    fill="currentColor"
                  ></path>
                  <path
                    d="M12 10.7617C12 11.8663 11.1046 12.7617 10 12.7617C8.89543 12.7617 8 11.8663 8 10.7617C8 9.65715 8.89543 8.76172 10 8.76172C11.1046 8.76172 12 9.65715 12 10.7617Z"
                    fill="currentColor"
                  ></path>
                  <path
                    d="M12 17.7617C12 18.8663 11.1046 19.7617 10 19.7617C8.89543 19.7617 8 18.8663 8 17.7617C8 16.6571 8.89543 15.7617 10 15.7617C11.1046 15.7617 12 16.6571 12 17.7617Z"
                    fill="currentColor"
                  ></path>
                </svg>
              </button>
              <ul class="menu">
                <li>
                  <a class="kebab-menu-link" href="/">Surprise me</a>
                </li>
                <li class="kebab-menu-divider"></li>
                <li>
                  <a class="kebab-menu-link" href="/"
                    ><img
                      src="https://static-beta.curseforge.com/images/cf_legacy.png"
                      alt="legacy flame"
                    />Legacy</a
                  >
                </li>
              </ul>
            </div>
            <div class="user-actions"><div class="user-loading"></div></div>
          </nav>
        </header>
        <main>
          <div class="home-page container">
            <img
              class="fire-bg"
              src="https://static-beta.curseforge.com/images/home/fire-bg.webp"
              alt="home background image"
            />
            <div class="home-title">
              <h1>
                Well come to <span>{{ proName }}</span>
              </h1>
            </div>
            <div class="search-bar-with-suggestions">
              <div class="search-bar">
                <label class="search-input-field-label"
                  ><input
                    class="search-input-field"
                    type="search"
                    autocomplete="off"
                    aria-label="Search for a game"
                    placeholder="Search for a game..."
                    maxlength="80"
                    value=""
                /></label>
              </div>
            </div>
            <section class="shelf">
              <div class="inner">
                <h2>Featured Games</h2>
                <div class="content">
                  <ul class="tiles-list">
                    <li
                      v-for="item in gameList"
                      :key="item.id"
                      @click="navigateToGame(item.aHerf)"
                    >
                      <a class="game-tile">
                        <div class="art">
                          <img
                            id="row-image"
                            alt="Minecraft game art"
                            loading="lazy"
                            width="184"
                            height="231"
                            decoding="async"
                            data-nimg="1"
                            style="color: transparent"
                            :src="item.gameImageUrl"
                          />
                        </div>
                        <h3>{{ item.gameName }}</h3>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </section>
            <div class="desktop-only">
              <a href="/" aria-label="premium banner"
                ><img
                  alt="premium banner"
                  loading="lazy"
                  width="1224"
                  height="60"
                  decoding="async"
                  data-nimg="1"
                  class="premium-banner"
                  style="color: transparent"
                  src="https://www.curseforge.com/images/premium/premium-banner.webp"
              /></a>
            </div>
            <section class="news-and-updates">
              <div
                class="news-slider move-left"
                data-scroll-animation-slides="1"
              >
                <div class="content">
                  <div class="carousel">
                    <div class="details">
                      <div class="details-box">
                        <ul class="slides">
                          <li class="slide-item slide-enter">
                            <a
                              href="/"
                              class="bg-image-container"
                              target="_blank"
                              rel="noopener noreferrer nofollow"
                              ><img
                                alt="slide background"
                                loading="lazy"
                                decoding="async"
                                data-nimg="fill"
                                style="
                                  position: absolute;
                                  height: 100%;
                                  width: 100%;
                                  left: 0;
                                  top: 0;
                                  right: 0;
                                  bottom: 0;
                                  color: transparent;
                                "
                                src="https://media.forgecdn.net/carousel-background-images/carousel_background_7487ee5e-6dfc-4a66-a729-879a12c1d5c1.webp"
                            /></a>
                            <div class="slide-details">
                              <div class="slide-tag">news</div>
                              <img
                                alt="game name"
                                loading="lazy"
                                width="182"
                                height="70"
                                decoding="async"
                                data-nimg="1"
                                class="game-logo"
                                style="color: transparent"
                                src="https://media.forgecdn.net/carousel-logo-images/carousel-logo_777da06c-aeb7-4e36-8ea7-5b5ca1691eca.webp"
                              />
                              <h3>
                                <span>Creator of the Month - Darkosto</span>
                              </h3>
                              <p>
                                <span
                                  >Meet our latest Creator of the Month,
                                  responsible for the SkyFactory modpack series,
                                  which lets you view the world in a way you
                                  never have before!</span
                                >
                              </p>
                            </div>
                          </li>
                          <li class="slide-item">
                            <a
                              href="/"
                              class="bg-image-container"
                              target="_blank"
                              rel="noopener noreferrer nofollow"
                              ><img
                                alt="slide background"
                                loading="lazy"
                                decoding="async"
                                data-nimg="fill"
                                style="
                                  position: absolute;
                                  height: 100%;
                                  width: 100%;
                                  left: 0;
                                  top: 0;
                                  right: 0;
                                  bottom: 0;
                                  color: transparent;
                                "
                                src="https://media.forgecdn.net/carousel-background-images/carousel_background_d0793ff0-c608-445a-91ea-4b05d02e454e.webp"
                            /></a>
                            <div class="slide-details">
                              <div class="slide-tag">update</div>
                              <img
                                alt="game name"
                                loading="lazy"
                                width="182"
                                height="70"
                                decoding="async"
                                data-nimg="1"
                                class="game-logo"
                                style="color: transparent"
                                src="https://media.forgecdn.net/carousel-logo-images/carousel-logo_14997fa1-37ca-4404-92ad-d66d1b1e0a2f.webp"
                              />
                              <h3><span>Goblet of Mods Contest</span></h3>
                              <p>
                                <span
                                  >Show off your magic! Join the Hogwarts Legacy
                                  Modding Contest for a shot at a $100K prize
                                  pool and enchanting surprises. Submission
                                  starts Jan 30!</span
                                >
                              </p>
                              <div class="slide-cta">
                                <a
                                  class="link-btn btn-primary link-btn-icon"
                                  href="/"
                                  target="_blank"
                                  data-tooltip-id="curseforge-tooltip"
                                  rel=" noreferrer noopener"
                                  ><div><span>Learn More</span></div></a
                                >
                              </div>
                            </div>
                          </li>
                          <li class="slide-item">
                            <a
                              href="/"
                              class="bg-image-container"
                              target="_blank"
                              rel="noopener noreferrer nofollow"
                              ><img
                                alt="slide background"
                                loading="lazy"
                                decoding="async"
                                data-nimg="fill"
                                style="
                                  position: absolute;
                                  height: 100%;
                                  width: 100%;
                                  left: 0;
                                  top: 0;
                                  right: 0;
                                  bottom: 0;
                                  color: transparent;
                                "
                                src="https://media.forgecdn.net/carousel-background-images/carousel_background_5118cc41-3e2e-4b58-b5da-19fcbefdac5e.webp"
                            /></a>
                            <div class="slide-details">
                              <div class="slide-tag">news</div>
                              <img
                                alt="game name"
                                loading="lazy"
                                width="182"
                                height="70"
                                decoding="async"
                                data-nimg="1"
                                class="game-logo"
                                style="color: transparent"
                                src="https://media.forgecdn.net/carousel-logo-images/carousel-logo_e8099b18-52ff-4d9c-900c-e0afea1036ba.webp"
                              />
                              <h3>
                                <span>Hogwarts, Minecraft &amp; Big Wins</span>
                              </h3>
                              <p>
                                <span
                                  >Check out our February newsletter, with
                                  updates for Minecraft, Hogwarts, and
                                  more!</span
                                >
                              </p>
                              <div class="slide-cta">
                                <a
                                  class="link-btn btn-primary link-btn-icon"
                                  href="/"
                                  target="_blank"
                                  data-tooltip-id="curseforge-tooltip"
                                  rel=" noreferrer noopener"
                                  ><div><span>Read Blog</span></div></a
                                >
                              </div>
                            </div>
                          </li>
                          <li class="slide-item">
                            <a
                              href="/"
                              target="_blank"
                              rel="noopener noreferrer nofollow"
                              ><img
                                alt="slide background"
                                loading="lazy"
                                decoding="async"
                                data-nimg="fill"
                                style="
                                  position: absolute;
                                  height: 100%;
                                  width: 100%;
                                  left: 0;
                                  top: 0;
                                  right: 0;
                                  bottom: 0;
                                  color: transparent;
                                "
                                src="https://media.forgecdn.net/carousel-background-images/carousel_background_91377d99-802a-4941-a34e-b8c4d3efaf1e.webp"
                            /></a>
                            <div class="slide-details">
                              <div class="slide-tag">update</div>
                              <img
                                alt="game name"
                                loading="lazy"
                                width="182"
                                height="70"
                                decoding="async"
                                data-nimg="1"
                                class="game-logo"
                                style="color: transparent"
                                src="https://media.forgecdn.net/carousel-logo-images/carousel-logo_126e3d5e-e99b-4b7a-88f4-c756ab1528e0.webp"
                              />
                              <h3><span>Platform Release Notes</span></h3>
                              <p>
                                <span
                                  >We’re happy as always to bring you new
                                  features, bug fixes, and improvements across
                                  our platform.</span
                                >
                              </p>
                              <div class="slide-cta">
                                <a
                                  class="link-btn btn-primary link-btn-icon"
                                  href="/"
                                  target="_blank"
                                  data-tooltip-id="curseforge-tooltip"
                                  rel=" noreferrer noopener"
                                  ><div><span>See notes</span></div></a
                                >
                              </div>
                            </div>
                          </li>
                          <li class="slide-item">
                            <a
                              href="/"
                              class="bg-image-container"
                              target="_blank"
                              rel="noopener noreferrer nofollow"
                              ><img
                                alt="slide background"
                                loading="lazy"
                                decoding="async"
                                data-nimg="fill"
                                style="
                                  position: absolute;
                                  height: 100%;
                                  width: 100%;
                                  left: 0;
                                  top: 0;
                                  right: 0;
                                  bottom: 0;
                                  color: transparent;
                                "
                                src="https://media.forgecdn.net/carousel-background-images/carousel_background_85ad036b-ba5d-4e61-b02c-620b46bc2f0d.webp"
                            /></a>
                            <div class="slide-details">
                              <div class="slide-tag">update</div>
                              <img
                                alt="game name"
                                loading="lazy"
                                width="182"
                                height="70"
                                decoding="async"
                                data-nimg="1"
                                class="game-logo"
                                style="color: transparent"
                                src="https://media.forgecdn.net/carousel-logo-images/carousel-logo_66e73b92-3969-4b63-9e3c-a93448f4212a.webp"
                              />
                              <h3>
                                <span
                                  >Discover the Best Mods, Addons &amp; CC</span
                                >
                              </h3>
                              <p>
                                <span
                                  >Our mod-obsessed team is on the hunt for the
                                  best content on CurseForge, so you won&#x27;t
                                  have to!</span
                                >
                              </p>
                              <div class="slide-cta">
                                <a
                                  class="link-btn btn-primary link-btn-icon"
                                  href="/"
                                  target="_blank"
                                  data-tooltip-id="curseforge-tooltip"
                                  rel=" noreferrer noopener"
                                  ><div><span>View Collections</span></div></a
                                >
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section class="shelf shelf-two-columns">
              <div class="inner">
                <ul class="tiles-list">
                  <li class="promo-card">
                    <div class="promo-card-img-container">
                      <img
                        alt="promotional banner"
                        loading="lazy"
                        decoding="async"
                        data-nimg="fill"
                        style="
                          position: absolute;
                          height: 100%;
                          width: 100%;
                          left: 0;
                          top: 0;
                          right: 0;
                          bottom: 0;
                          color: transparent;
                        "
                        src="https://www.curseforge.com/images/home/author.webp"
                      />
                    </div>
                    <h2>Become an Author and get rewarded!</h2>
                    <p>
                      Upload your projects to enjoy awesome management tools and
                      get rewarded for your creations.
                    </p>
                  </li>
                  <li class="promo-card">
                    <div class="promo-card-img-container">
                      <img
                        alt="promotional banner"
                        loading="lazy"
                        decoding="async"
                        data-nimg="fill"
                        style="
                          position: absolute;
                          height: 100%;
                          width: 100%;
                          left: 0;
                          top: 0;
                          right: 0;
                          bottom: 0;
                          color: transparent;
                        "
                        src="https://www.curseforge.com/images/home/app.webp"
                      />
                    </div>
                    <h2>Check out the CurseForge desktop app!</h2>
                    <p>
                      Easily manage your mods and addons for your favorite
                      games, and enjoy exciting new features!
                    </p>
                  </li>
                </ul>
              </div>
            </section>
            <img
              alt="home bottom anvil"
              loading="lazy"
              width="1082"
              height="564"
              decoding="async"
              data-nimg="1"
              class="ending-img"
              style="color: transparent; height: auto"
              src="https://static-beta.curseforge.com/images/home/sadan.webp"
            />
          </div>
        </main>
        <!--$--><!--/$--><!--$--><!--/$-->
        <footer class="site-footer">
          <div class="site-footer-inner">
            <div class="slogan">
              CurseForge - a world of endless gaming possibilities for modders
              and gamers alike.<br />Download the best mods and addons!
            </div>
            <div class="site-footer-nav">
              <nav>
                <ul>
                  <li>
                    <div class="section-header">Games</div>
                    <ul>
                      <li><a href="/">All games</a></li>
                      <li><a href="/">Minecraft</a></li>
                      <li><a href="/">World of Warcraft</a></li>
                      <li><a href="/">The Sims 4</a></li>
                      <li><a href="/">Starcraft II</a></li>
                      <li><a href="/">Kerbal Space Program</a></li>
                      <li>
                        <a href="/">Minecraft Dungeons</a>
                      </li>
                      <li><a href="/">World of Tanks</a></li>
                    </ul>
                  </li>
                  <li>
                    <div class="section-header">Create</div>
                    <ul>
                      <li>
                        <a href="/" target="_blank" rel="noopener noreferrer"
                          >Start a project</a
                        >
                      </li>
                      <li>
                        <a href="/" target="_blank" rel="noopener noreferrer"
                          >Project submission guide</a
                        >
                      </li>
                      <li>
                        <a href="/" target="_blank" rel="noopener noreferrer"
                          >Author Rewards Program</a
                        >
                      </li>
                      <li>
                        <a href="/" target="_blank" rel="noopener noreferrer"
                          >Apply for an API Key</a
                        >
                      </li>
                      <li>
                        <a href="/" target="_blank" rel="noopener noreferrer"
                          >3rd Party API T&amp;C</a
                        >
                      </li>
                    </ul>
                  </li>
                  <li>
                    <div class="section-header">Community</div>
                    <ul>
                      <li>
                        <a href="/" target="_blank" rel="noopener noreferrer"
                          >Join Our Discord!</a
                        >
                      </li>
                      <li>
                        <a href="/" target="_blank" rel="noopener noreferrer"
                          >Ideas Portal</a
                        >
                      </li>
                      <li>
                        <a href="/" target="_blank" rel="noopener noreferrer"
                          >CF blog</a
                        >
                      </li>
                      <li>
                        <a href="/" target="_blank" rel="noopener noreferrer"
                          >Newsletter</a
                        >
                      </li>
                      <li>
                        <a href="/" target="_blank" rel="noopener noreferrer"
                          >Roadmap</a
                        >
                      </li>
                      <li>
                        <a
                          href="/"
                          target="_blank"
                          rel="noopener noreferrer nofollow"
                          >Bukkit forums</a
                        >
                      </li>
                      <li>
                        <a href="/" target="_blank" rel="noopener noreferrer"
                          >CurseForge Servers</a
                        >
                      </li>
                    </ul>
                  </li>
                  <li>
                    <div class="section-header">Support</div>
                    <ul>
                      <li>
                        <a href="/" target="_blank" rel="noopener noreferrer"
                          >Knowledge base</a
                        >
                      </li>
                      <li>
                        <a href="/" target="_blank" rel="noopener noreferrer"
                          >Troubleshooting</a
                        >
                      </li>
                      <li>
                        <a href="/" target="_blank" rel="noopener noreferrer"
                          >Contact us</a
                        >
                      </li>
                    </ul>
                  </li>
                  <li class="half">
                    <div class="section-header">Companions</div>
                    <ul>
                      <li>
                        <a href="/" target="_blank" rel="noopener noreferrer"
                          >Overwolf</a
                        >
                      </li>
                      <li>
                        <a href="/" target="_blank" rel="noopener noreferrer"
                          >CurseForge for Studios</a
                        >
                      </li>
                      <li>
                        <a href="/" target="_blank" rel="noopener noreferrer"
                          >Tebex</a
                        >
                      </li>
                      <li>
                        <a href="/" target="_blank" rel="noopener noreferrer"
                          >Nitro</a
                        >
                      </li>
                    </ul>
                  </li>
                  <li class="half">
                    <div class="section-header">CurseForge Brand</div>
                    <ul>
                      <li>
                        <a href="/" target="_blank" rel="noopener noreferrer"
                          >CurseForge Brand Guidelines</a
                        >
                      </li>
                    </ul>
                  </li>
                </ul>
              </nav>
            </div>
            <div class="footer-bottom">
              <ul>
                <li>
                  <a href="/" target="_blank" rel="noopener noreferrer"
                    >Terms of Service</a
                  >
                </li>
                <li>
                  <a href="/" target="_blank" rel="noopener noreferrer"
                    >Privacy Policy</a
                  >
                </li>
                <li>
                  <a href="/" target="_blank" rel="noopener noreferrer"
                    >Licenses</a
                  >
                </li>
                <li>
                  <a href="/" target="_blank" rel="noopener noreferrer"
                    >Mod Author Terms</a
                  >
                </li>
                <li id="ncmp-consent-link" class="consent"></li>
              </ul>
            </div>
            <div class="copyright">
              ©
              <!-- -->2025 Overwolf. All rights reserved.
            </div>
          </div>
        </footer>
      </div>
    </body>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import { useRouter } from "vue-router";
const router = useRouter();
const topLogoStyle2 = require("@/assets/image/logo-white.png");
// 菜单列表
const meunList = [
  {
    name: "Games",
    skipUrl: "/",
  },
  {
    name: "Mods",
    skipUrl: "/",
  },
  {
    name: "Collections",
    skipUrl: "/",
  },
  {
    name: "Media",
    skipUrl: "/",
  },
  {
    name: "Community",
    skipUrl: "/",
  },
  {
    name: "Support",
    skipUrl: "/",
  },
];
// 游戏列表
const gameList = ref([
  {
    gameName: "Paper Doll Fo",
    aHerf: "1",
    gameImageUrl: require("@/assets/image/gameImg/y1.png"),
    bigFlag: false,
    alt: "Paper Doll For Girls Dress Up",
    score: "8.0bn",
  },
  {
    gameName: "Color Link Challenge",
    aHerf: "2",
    gameImageUrl: require("@/assets/image/gameImg/y2.png"),
    bigFlag: false,
    alt: "Color Link Challenge",
    score: "8.0bn",
  },
  {
    gameName: "Car Jam Color",
    aHerf: "3",
    gameImageUrl: require("@/assets/image/gameImg/y3.png"),
    bigFlag: true,
    alt: "Car Jam Color",
    score: "8.0bn",
  },
  {
    gameName: "Happy Glass",
    aHerf: "4",
    gameImageUrl: require("@/assets/image/gameImg/y4.png"),
    bigFlag: false,
    alt: "Happy Glass",
    score: "8.0bn",
  },
  {
    gameName: "Slide Blocks",
    aHerf: "5",
    gameImageUrl: require("@/assets/image/gameImg/y5.png"),
    bigFlag: false,
    alt: "Slide Blocks Puzzle",
    score: "7.8bn",
  },
  {
    gameName: "Cannon Balls",
    aHerf: "6",
    gameImageUrl: require("@/assets/image/gameImg/y6.png"),
    bigFlag: false,
    alt: "Cannon Balls - Arcade",
    score: "7.8bn",
  },
  {
    gameName: "Basketball Sw",
    aHerf: "7",
    gameImageUrl: require("@/assets/image/gameImg/y7.png"),
    bigFlag: false,
    alt: "Basketball Swooshes",
    score: "7.8bn",
  },
  {
    gameName: "Build Tower",
    aHerf: "8",
    gameImageUrl: require("@/assets/image/gameImg/y8.png"),
    bigFlag: false,
    alt: "Build Tower",
    score: "7.8bn",
  },
  {
    gameName: "Mushroom Pop",
    aHerf: "9",
    gameImageUrl: require("@/assets/image/gameImg/y9.png"),
    bigFlag: false,
    alt: "Mushroom Pop",
    score: "7.8bn",
  },
  {
    gameName: "Jumper Bot",
    aHerf: "10",
    gameImageUrl: require("@/assets/image/gameImg/y10.png"),
    bigFlag: false,
    alt: "Jumper Bot",
    score: "7.8bn",
  },
  {
    gameName: "Ghost Float",
    aHerf: "11",
    gameImageUrl: require("@/assets/image/gameImg/y11.png"),
    bigFlag: false,
    alt: "Ghost Float",
    score: "7.6bn",
  },
  {
    gameName: "Flamingo Bing",
    aHerf: "12",
    gameImageUrl: require("@/assets/image/gameImg/y12.png"),
    bigFlag: false,
    alt: "Flamingo Bingo",
    score: "7.6bn",
  },
  {
    gameName: "Zombie Wipeou",
    aHerf: "13",
    gameImageUrl: require("@/assets/image/gameImg/y13.png"),
    bigFlag: false,
    alt: "Zombie Wipeout",
    score: "7.6bn",
  },
  {
    gameName: "Dd Pixel Slid",
    aHerf: "14",
    gameImageUrl: require("@/assets/image/gameImg/y14.png"),
    bigFlag: true,
    alt: "Dd Pixel Slide",
    score: "7.6bn",
  },
  {
    gameName: "Swipe The Pin",
    aHerf: "15",
    gameImageUrl: require("@/assets/image/gameImg/y15.png"),
    bigFlag: false,
    alt: "Swipe The Pin",
    score: "7.6bn",
  },
  {
    gameName: "Oomee Piñata",
    aHerf: "16",
    gameImageUrl: require("@/assets/image/gameImg/y16.png"),
    bigFlag: false,
    alt: "Oomee Piñata",
    score: "7.6bn",
  },
  {
    gameName: "Changer Jam",
    aHerf: "17",
    gameImageUrl: require("@/assets/image/gameImg/y17.png"),
    bigFlag: false,
    alt: "Changer Jam",
    score: "7.6bn",
  },
  {
    gameName: "Find The Set",
    aHerf: "18",
    gameImageUrl: require("@/assets/image/gameImg/y18.png"),
    bigFlag: false,
    alt: "Find The Set",
    score: "7.6bn",
  },
]);

// 底部游戏列表
const gameBottomList = ref([
  {
    gameName: "Fire And Wate",
    aHerf: "21",
    gameImageUrl: require("@/assets/image/gameImg/y21.png"),
    bigFlag: false,
    alt: "Fire And Water Stickman",
    viewNum: 5555,
    score: "8.0bn",
  },
  {
    gameName: "2048 Champion",
    aHerf: "22",
    gameImageUrl: require("@/assets/image/gameImg/y22.png"),
    bigFlag: true,
    alt: "2048 Champion",
    viewNum: 2137,
    score: "7.8bn",
  },
  {
    gameName: "Clones",
    aHerf: "23",
    gameImageUrl: require("@/assets/image/gameImg/y23.png"),
    bigFlag: false,
    alt: "Clones",
    viewNum: 1555,
    score: "7.6bn",
  },
  {
    gameName: "Firefighter R",
    aHerf: "24",
    gameImageUrl: require("@/assets/image/gameImg/y24.png"),
    bigFlag: false,
    alt: "Firefighter Rescue Quest",
    viewNum: 780,
    score: "7.6bn",
  },
  {
    gameName: "Dragon's Defe",
    aHerf: "25",
    gameImageUrl: require("@/assets/image/gameImg/y25.png"),
    bigFlag: false,
    alt: "Dragon's Defense Reign Of Fire",
    viewNum: 1323,
    score: "5.6bn",
  },
  {
    gameName: "Chin Up Shin",
    aHerf: "26",
    gameImageUrl: require("@/assets/image/gameImg/y26.png"),
    bigFlag: true,
    alt: "Chin Up Shin Up",
    viewNum: 1209,
    score: "6.1bn",
  },
  {
    gameName: "Counter Craft",
    aHerf: "27",
    gameImageUrl: require("@/assets/image/gameImg/y27.png"),
    bigFlag: false,
    alt: "Counter Craft 5",
    viewNum: 879,
    score: "7.2bn",
  },
  {
    gameName: "The Bomb",
    aHerf: "28",
    gameImageUrl: require("@/assets/image/gameImg/y28.png"),
    bigFlag: true,
    alt: "The Bomb",
    viewNum: 860,
    score: "7.7bn",
  },
  {
    gameName: "Princesses At",
    aHerf: "29",
    gameImageUrl: require("@/assets/image/gameImg/y29.png"),
    bigFlag: false,
    alt: "Princesses At Horror School",
    viewNum: 531,
    score: "7.9bn",
  },
  {
    gameName: "Number Match",
    aHerf: "30",
    gameImageUrl: require("@/assets/image/gameImg/y30.png"),
    bigFlag: false,
    alt: "Number Match - Match Ten",
    viewNum: 768,
    score: "7.5bn",
  },
  {
    gameName: "Ultimate Noug",
    aHerf: "31",
    gameImageUrl: require("@/assets/image/gameImg/y31.png"),
    bigFlag: false,
    alt: "Ultimate Noughts &amp; Crosses",
    viewNum: 980,
    score: "7.1bn",
  },
  {
    gameName: "Arrowblob Puz",
    aHerf: "32",
    gameImageUrl: require("@/assets/image/gameImg/y32.png"),
    bigFlag: false,
    alt: "Arrowblob Puzzle Quest",
    viewNum: 988,
    score: "6.2bn",
  },
  {
    gameName: "Ascend",
    aHerf: "33",
    gameImageUrl: require("@/assets/image/gameImg/y33.png"),
    bigFlag: false,
    alt: "Ascend",
    viewNum: 586,
    score: "5.6bn",
  },
  {
    gameName: "Race",
    aHerf: "34",
    gameImageUrl: require("@/assets/image/gameImg/y34.png"),
    bigFlag: false,
    alt: "Race",
    viewNum: 245,
    score: "8.6bn",
  },
  {
    gameName: "Tanks Battle",
    aHerf: "35",
    gameImageUrl: require("@/assets/image/gameImg/y35.png"),
    bigFlag: false,
    alt: "Tanks Battle Field",
    viewNum: 856,
    score: "8.6bn",
  },
  {
    gameName: "Battlegrid On",
    aHerf: "36",
    gameImageUrl: require("@/assets/image/gameImg/y36.png"),
    bigFlag: false,
    alt: "Battlegrid Online Pvp Tank Battles",
    viewNum: 153,
    score: "8.8bn",
  },
  {
    gameName: "Pumpkin Of Go",
    aHerf: "37",
    gameImageUrl: require("@/assets/image/gameImg/y37.png"),
    bigFlag: false,
    alt: "Pumpkin Of Goo",
    viewNum: 122,
    score: "8.6bn",
  },
  {
    gameName: "Apostle's Cre",
    aHerf: "38",
    gameImageUrl: require("@/assets/image/gameImg/y38.png"),
    bigFlag: false,
    alt: "Apostle's Creed I",
    viewNum: 436,
    score: "7.9bn",
  },
  {
    gameName: "Zombie Runner",
    aHerf: "39",
    gameImageUrl: require("@/assets/image/gameImg/y39.png"),
    bigFlag: true,
    alt: "Zombie Runner",
    viewNum: 1152,
    score: "7.8bn",
  },
  {
    gameName: "Fruit Name Ju",
    aHerf: "40",
    gameImageUrl: require("@/assets/image/gameImg/y40.png"),
    bigFlag: false,
    alt: "Fruit Name Jump",
    viewNum: 867,
    score: "7.6bn",
  },
]);
const navigateToGame = (index) => {
  router.push({ name: "play", query: { gameId: index } });
};
const handleClickBottomBtn = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

const proName = process.env.VUE_APP_PROJECTNAME;
/**
 * adsense
 */
const clientId = process.env.VUE_APP_ADSENSEID;
const clientslotId = process.env.VUE_APP_ADSENSESLOTID;

const loadAds = () => {
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${process.env.VUE_APP_ADSENSEID}`;
  script.crossOrigin = "anonymous";

  // 创建并配置 <ins> 元素
  const ins = document.createElement("ins");
  ins.className = "adsbygoogle";
  ins.style.display = "block";

  ins.setAttribute("data-ad-client", process.env.VUE_APP_ADSENSEID);
  ins.setAttribute("data-ad-slot", process.env.VUE_APP_ADSENSESLOTID);
  const adContainer = document.getElementById("ad-container");
  if (adContainer) {
    adContainer.appendChild(script);
    adContainer.appendChild(ins);

    setTimeout(() => {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    }, 1000);
  } else {
    console.error("Ad container not found!");
  }
};
const loadAds2 = () => {
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${process.env.VUE_APP_ADSENSEID}`;
  script.crossOrigin = "anonymous";

  const ins = document.createElement("ins");
  ins.className = "adsbygoogle";
  ins.style.display = "block";
  ins.setAttribute("data-ad-client", process.env.VUE_APP_ADSENSEID);
  ins.setAttribute("data-ad-slot", process.env.VUE_APP_ADSENSESLOTID);

  const adContainer = document.getElementById("ad-container2");
  if (adContainer) {
    adContainer.appendChild(script);
    adContainer.appendChild(ins);

    setTimeout(() => {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    }, 1000);
  } else {
    console.error("Ad container not found!");
  }
};
const bottomLogo = require("@/assets/image/logo.jpg");
const topLogo = require("@/assets/image/logo-white.png");

onMounted(() => {
  loadAds();
  loadAds2();
});
</script>

<style lang="scss" scoped>
.notification {
  display: flex;
  font-size: 14px;
  color: white;
  width: 100%;
  justify-content: space-between;
}

.notification-link {
  width: 80%;
}

.notification-category-icon-wrapper {
  width: 15%;
}

.notification-category-specific-icon {
  border-radius: 20px;
  object-fit: cover;
  object-position: center;
}

.notification-category-generic-icon,
.notification-category-specific-icon {
  width: 30px;
  height: 30px;
}

.notification-content {
  width: 85%;
}

.notifications-list ul li .notification-bold,
.notifications-list ul li .text-primary,
.notifications-list ul li .text-primary-moderate {
  display: inline;
  font-weight: 600;
  color: var(--rj-orange-font);
}

.notifications-list ul li .notification-content > div:first-child {
  min-height: 40px;
}

.notification-row {
  margin-bottom: 10px;
}

.notification-date {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
}

.notification-icon {
  border-radius: 21px;
  height: 42px;
  width: 42px;
  background-repeat: no-repeat;
  background-size: 42px 42px;
  margin-right: 10px;
}

.notification-indicator-wrapper {
  height: 100%;
  width: 12%;
}

.notification-indicator-box {
  visibility: hidden;
  width: 24px;
  height: 24px;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.expanding-hover {
  position: relative;
}

.expanding-hover::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  height: 0;
  width: 0;
  border-radius: 100%;
  background-color: var(--rj-white-30);
  transition-property: height, width, top, left;
  transition-duration: 0.25s;
  transition-timing-function: ease-in-out;
}

.expanding-hover:hover::before {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}

.notification-wrapper.notification-unread .notification-indicator-box {
  visibility: visible;
}

.notification-indicator {
  border-radius: 4px;
  width: 8px;
  height: 8px;
  margin: auto;
  background: var(--rj-orange-font);
  padding: 0;
  border: 0;
}

.icons-row {
  display: flex;
}

.notification-menu-wrapper {
  width: 8%;
  display: flex;
  height: 24px;
  justify-content: center;
}

.notification-menu-button {
  width: 24px;
  background: none;
  border: 0;
  padding: 0;
}

.notification-menu-hidden {
  display: hidden;
}

.notification-menu {
  background-color: var(--rj-nexusblack-high-contrast);
  display: none;
  font-family: Montserrat;
  text-transform: uppercase;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  z-index: 1;
  opacity: 1;
  border-radius: 4px;
  border: 1px solid #3e413f;
}

.notification-menu-row {
  display: flex;
  height: 48px;
  align-items: center;
  box-sizing: border-box;
  padding: 12px 10px 12px 16px;
  gap: 10px;
}

.notification-menu-row.notification-remove {
  margin-top: 16px;
  position: relative;
}

.notification-menu-row.notification-remove:before {
  content: "";
  background: #3c3f44;
  height: 1px;
  padding: 0;
  position: absolute;
  top: -8px;
  left: 7px;
  right: 7px;
}

.notification-menu-row:hover {
  background-color: var(--rj-white-05);
}

.notification-mark-as-read,
.notification-mark-as-unread {
  display: none;
}

.notification-wrapper.notification-unread .notification-mark-as-read {
  display: flex;
}

.notification-wrapper.notification-read .notification-mark-as-unread {
  display: flex;
}

.notification-menu-icon-wrapper {
  padding: 0;
  margin: 0;
  width: 24px;
}

.notification-menu-icon {
  padding: 0;
  margin: 0;
  width: 24px;
}

.notification-menu-text {
  background: none;
  border: 0;
  text-transform: uppercase;
  padding: 0;
  margin: 0;
  letter-spacing: 1.4px;
  white-space: nowrap;
}

.notification-read .notification {
  opacity: 0.5;
}

@media (min-width: 1024px) {
  .notification-category-generic-icon,
  .notification-category-specific-icon {
    width: 35px;
    height: 35px;
  }
  .notification-wrapper:hover .notification-menu-wrapper,
  .notification-wrapper:focus-within .notification-menu-wrapper {
    visibility: visible;
  }
  .notification-menu-wrapper {
    visibility: hidden;
  }
}

.notification-menu {
  position: absolute;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  top: 47px;
  right: 20px;
}

.collections-banner-outer-wrapper-trigger .collections-banner-wrapper {
  background: #2d2d2d;
  padding: 32px 16px;
}

.collections-banner {
  position: relative;
  width: 100%;
  background: #0555b8;
  color: white;
  height: 68px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  padding: 16px;
  font-family: montserrat;
  cursor: pointer;
  gap: 12px;
  font-size: 18px;
  letter-spacing: 0.15px;
}

.collections-banner > span {
  position: relative;
}

.collections-banner:hover {
  color: white;
}

.collections-banner__splash {
  display: none;
  position: absolute;
  right: 4px;
  top: 4px;
  bottom: 4px;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 60px 100%);
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  overflow: hidden;
  width: calc(100% - 600px);
  max-width: 644px;
}

.collections-banner__splash-image {
  height: 100%;
  object-fit: cover;
  object-position: 0%;
}

@media only screen and (min-width: 768px) {
  .collections-banner__splash {
    display: block;
  }
}

.premium-block {
  position: relative;
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}

.premium-block.premium-block--register {
  align-items: center;
}

.premium-block--register .premium-block__link-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.premium-block--register .premium-block__link-wrapper > a {
  margin-bottom: 16px;
}

.premium-block--register .premium-block__link-wrapper > span {
  font-weight: bold;
  color: rgba(255, 255, 255, 0.8);
}

.premium-block--register .premium-block__text-wrapper {
  text-align: center;
}

.premium-block--register .premium-block__text-wrapper h2 {
  width: 100%;
}

.premium-block.background-1 {
  background: linear-gradient(to right, #040404, 70%, transparent),
    url("https://staticdelivery.nexusmods.com/Images/ad_bg_1.png") right/60%
      no-repeat,
    #040404;
}

.premium-block.background-2 {
  background: linear-gradient(to right, #040404, 70%, transparent),
    url("https://staticdelivery.nexusmods.com/Images/ad_bg_2.png") right/60%
      no-repeat,
    #040404;
}

.premium-block.hidden {
  display: none;
}

.premium-block::before {
  top: 0;
}

.premium-block::after {
  bottom: 0;
}

.premium-block__text-wrapper {
  text-align: left;
  width: 100%;
  margin-bottom: 16px;
}

.premium-block__link-wrapper {
  text-align: left;
}

.premium-block__text-wrapper h2 {
  font-family: "Roboto", Helvetica, Arial, sans-serif;
  font-weight: bold;
  font-size: 24px;
  width: 80%;
}

.premium-block__text-wrapper p {
  font-weight: 400;
  color: rgba(225, 225, 225, 0.8);
}

.premium-block__link-wrapper > a.rj-btn {
  width: 200px;
}

.premium-block--register .premium-block__link-wrapper > a.rj-btn {
  width: 100%;
}

.premium-block__link-wrapper > a.rj-btn i:last-child {
  margin-left: 8px;
}

@media (min-width: 768px) {
  .premium-block {
    padding: 32px 16px;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
  }
  .premium-block__text-wrapper {
    width: 70%;
    margin-bottom: 0;
  }
  .premium-block--register .premium-block__text-wrapper {
    width: 50%;
    text-align: left;
  }
  .premium-block--register .premium-block__link-wrapper > a.rj-btn {
    width: 200px;
  }
}

@media (min-width: 1000px) {
  .premium-block__text-wrapper {
    text-align: center;
  }
  .premium-block--register .premium-block__text-wrapper {
    width: 50%;
    text-align: center;
  }
  .premium-block__link-wrapper {
    text-align: center;
  }
  .premium-block__text-wrapper h2 {
    font-size: 32px;
    width: 100%;
  }
  .premium-block__text-wrapper br {
    display: none;
  }
}
</style>
